module.exports = __webpack_public_path__ + "media/images/flags/tt-526844fdfcdee69a0684228c617b0f08.svg";